export const cableOrderRow = (value) => async (dispatch, getState) => {
  const { orders } = getState();
  const { total_price, order_row } = value;
  let variables = {};
  if (orders.order?.id == order_row?.order_id) {
    variables.order_rows = orders.order_rows;
    variables.order = {
      ...orders.order,
      total_price,
    };

    if (orders.order_rows.find((d) => d.id == order_row.id)) {
      variables.order_rows = variables.order_rows.map((d) =>
        d.id == order_row.id ? { ...d, ...order_row } : d
      );
    } else {
      variables.order_rows = [...orders.order_rows, order_row];
    }
  }

  const find_order_index = orders.orders.findIndex(
    (d) => d.id == order_row.order_id
  );
  if (find_order_index != -1) {
    variables.orders = orders.orders;
    if (
      variables.orders[find_order_index].order_rows.find(
        (d) => d.id == order_row.id
      )
    )
      variables.orders[find_order_index].order_rows = variables.orders[
        find_order_index
      ].order_rows.map((d) =>
        d.id == order_row.id ? { ...d, ...order_row } : d
      );
    else variables.orders[find_order_index].order_rows.push(order_row);
  }

  // console.log({ variables });
  if (Object.keys(variables).length == 0) return;
  dispatch({
    type: "CABLE_POST_ORDER_ROW",
    payload: variables,
  });
};
